import React from 'react';
import Breadcrumb from 'src/components/Breadcrumb';
import { isRole } from 'src/helpers/permissions';
import { PATHS, USER_ROLES } from 'src/common/constants';

interface ServiceRequestBreadcrumbProps {
  user: any;
  location: any;
  branding: any;
}

const ServiceRequestBreadcrumb = ({
  user,
  location,
  branding,
}: ServiceRequestBreadcrumbProps) => {
  const navigateToFromState: string | undefined = location?.state?.navigateTo;
  const navLabelFromState: string | undefined = location?.state?.navLabel;
  const fallbackLabel: string = branding.text.serviceRequest + 's';

  if (navigateToFromState) {
    return (
      <Breadcrumb
        to={navigateToFromState}
        label={navLabelFromState ?? fallbackLabel}
      />
    );
  }

  if (isRole(USER_ROLES.HOME_OWNER, user)) {
    return <Breadcrumb to={PATHS.DASHBOARD} label="Dashboard" />;
  }

  return <Breadcrumb to={PATHS.SERVICE_REQUESTS_LIST} label={fallbackLabel} />;
};

export default ServiceRequestBreadcrumb;